import {
  IdentityIsoResult,
  PointResult,
  SearchResult,
} from "server/coreApi/search/get/models.js";

export enum SearchDataType {
  CUSTOMER_CRM_KEY = "customerCRMKey",
  CUSTOMER_NAME = "customerName",
  CUSTOMER_GEOLOCATION = "customerGeoLocationName",
  POINT_NAME = "pointName",
  IDENTITY_ISO = "identityIso",
}

export type NormalizedSearchResult = (
  SearchResult | PointResult | IdentityIsoResult
) & {
  type: SearchDataType;
};

export const TERMINAL_KEY = "terminal";
export const ACCESS_PARENT_KEY = "accessParent";
export const DEPOT_KEY = "depot";
export const CONTAINER_KEY = "container";
export const CUSTOMER_REFERENCE_KEY = "customerReference";
export const IDENTITY_KEY = "identity";
